import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { configureStore } from "./StoreConfig";
import { deleteState } from "./Utilities/State";
import { initializeStore } from "./Actions/Actions";
import { useInitialDsjState } from "../data";

// This line shares one store between all DsjStoreProvider instances.  This breaks test isolation
// All tests in the same test file share the state.  However, the application might be relying on
// this behaviour.
var store = configureStore();
var DsjStoreProvider = function DsjStoreProvider(_ref) {
  var children = _ref.children,
    id = _ref.id,
    loadingElement = _ref.loadingElement;
  var _useInitialDsjState = useInitialDsjState(id, {
      enabled: Boolean(id)
    }),
    initialDsjState = _useInitialDsjState.initialDsjState,
    isLoadingInitialDsjState = _useInitialDsjState.isLoadingInitialDsjState;

  // eslint-disable-next-line no-restricted-syntax -- legitimate use of useEffect
  useEffect(function () {
    if (id) {
      deleteState();
    }
  }, [id]);

  // eslint-disable-next-line no-restricted-syntax -- legitimate use of useEffect
  useEffect(function () {
    store.dispatch(initializeStore(initialDsjState));
  }, [initialDsjState]);
  if (isLoadingInitialDsjState) {
    // can remove this fragment wrapper after TypeScript 5.1
    return /*#__PURE__*/React.createElement(React.Fragment, null, loadingElement);
  }
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, children);
};
export default DsjStoreProvider;